import { createContext, useContext } from 'react';

const CommuneContext = createContext();

export function CommuneProvider({ children, value }) {
  return <CommuneContext.Provider value={value}>{children}</CommuneContext.Provider>;
}

export function useCommune() {
  return useContext(CommuneContext);
}